import { FC } from 'react'

import LeadDetails from '../LeadDetails'
import Conversation from '../Conversation'
import { LeadDetailData } from '@forwardflow/services/LeadService'
import { Spinner } from '@forwardflow/ui'
import DemoConversation from '../Conversation/DemoConversation'
import DemoLeadDetails from '../Conversation/DemoLeadDetails'
import { useGetDefaultConfigurations } from '@forwardflow/hooks/customHooks/useGetDefaultConfigurations'

interface ConversationsProps {
   selectedLeadDetails: LeadDetailData | undefined | null
   isLoading: boolean
}
const Conversations: FC<ConversationsProps> = ({ selectedLeadDetails, isLoading }) => {
   const { data } = useGetDefaultConfigurations()

   const newDemo = window.location.pathname.includes('demo-conversations') &&
      !window.location.pathname.includes('demo-conversations-old')

   if (isLoading) {
      return (
         <div className="min-h-[80vh] flex justify-center items-center bg-primary/10 rounded-lg">
            <Spinner />
         </div >
      )
   }

   if (selectedLeadDetails === null) {
      return (
         <div className="min-h-[80vh] flex justify-center items-center bg-primary/10 rounded-lg">
            <div className="text-white/70 text-sm">
               No conversation selected. Please select a lead from the list or change data source.
            </div>
         </div>
      )
   }

   if (selectedLeadDetails === undefined) {
      return (
         <div className="min-h-[80vh] flex justify-center items-center bg-primary/10 rounded-lg">
            <div className="text-white/70 text-sm">
               No lead details found with this lead Id
            </div>
         </div>
      )
   }

   return (
      <div className="flex flex-col h-full overflow-hidden rounded-lg bg-primary/10">
         <div className="flex h-full">
            {newDemo && data?.featureFlags?.enableNewDemoConversation === true ? (
               <DemoLeadDetails leadDetails={selectedLeadDetails} />
            ) : (
               <LeadDetails leadDetails={selectedLeadDetails} />
            )}
            <div className="flex flex-col w-full max-h-[860px] xl:max-h-full">
               {newDemo && data?.featureFlags?.enableNewDemoConversation === true ?
                  <DemoConversation selectedLeadDetails={selectedLeadDetails} />
                  :
                  <Conversation selectedLeadDetails={selectedLeadDetails} />
               }
            </div>
         </div>
      </div>
   )
}

export default Conversations
